import {
  Truck, Stethoscope, BarChart3, Users, Boxes, Radio,
  MessageSquareHeart, ShoppingBag, ShieldCheck, BrainCircuit,
  Building2, Sparkles,
} from "lucide-react";

export const CATEGORY_META = {
  "Logistics & Mobility": { icon: Truck, accent: "blue" },
  "Healthcare Systems": { icon: Stethoscope, accent: "blue" },
  "ERP & Sales Intelligence": { icon: BarChart3, accent: "gold" },
  "HR & Payroll": { icon: Users, accent: "gold" },
  "Inventory & Warehouse": { icon: Boxes, accent: "blue" },
  "Events & NFC Systems": { icon: Radio, accent: "gold" },
  "Customer Engagement Platforms": { icon: MessageSquareHeart, accent: "blue" },
  "Retail & POS": { icon: ShoppingBag, accent: "gold" },
  "Cybersecurity Systems": { icon: ShieldCheck, accent: "blue" },
  "AI & Automation": { icon: BrainCircuit, accent: "gold" },
  "Enterprise Custom Systems": { icon: Building2, accent: "blue" },
  "Memora Ecosystem": { icon: Sparkles, accent: "gold" },
};

export const CATEGORIES = Object.keys(CATEGORY_META);
